const movement = {title: 'Movimentar', href: '/wallets/movement'};
const manualEntry = {title: 'Lançamento manual', href: '/wallets/manual-entry'};

export const buildFinancialSubMenus = (isAdmin: boolean) => [
    {title: 'Análise de despesas', href: '/expenseanalysis'},
    {title: 'Análise de orçamentos', href: '/monthlybudgetanalysis'},
    {title: 'Bandeiras', href: '/brands'},
    {title: 'Documentos', href: '/documents'},
    {title: 'Contas', href: '/wallets'},
    {title: 'Fluxo de caixa', href: '/cashflow'},
    {title: 'Fluxo de pagamentos', href: '/paymentflux'},
    {title: 'Modelos fiscais', href: '/fiscalmodels'},
    movement,
    ...(isAdmin ? [manualEntry] : []),
    {title: 'Notas emitidas', href: '/nfe/consulta'},
    {title: 'Orçamento mensal', href: '/monthlybudget'},
    {title: 'Planos de contas', href: '/planodecontas'},
    {title: 'Registros de caixa', href: '/cashregisters'},
    {title: 'Tipos de gastos', href: '/centrodecustos'},
    {title: 'Tipos de pagamento', href: '/paymenttypes'},
    {title: 'Visão geral', href: '/financial/overview'}
];
